export const technicalSheet = {
	sections: {
		generalInfo: {
			title: "INFORMACIÓN GENERAL",
			preparationTime: {
				label: "Tiempo de preparación",
				placeholder: "00 minutos",
				unit: "minutos",
			},
		},
		ingredients: {
			title: "INGREDIENTES",
			addButton: "Agregar a la ficha",
			emptyState: {
				title: "No se han agregado ingredientes",
				message: "Agrega ingredientes para componer la ficha técnica",
			},
			inline: {
				product: "Producto/Ingrediente",
				quantity: "Cantidad",
				loss: "Pérdidas",
			},
			columns: {
				product: "PRODUCTO/INGREDIENTE",
				quantity: "CANTIDAD",
				loss: "PÉRDIDA",
				yield: "RENDIMIENTO",
				unitCost: "COSTO UNITARIO",
				unitCostTooltip: "El costo unitario es el promedio de todos los costos del producto",
				totalCost: "COSTO TOTAL",
				totalCostTooltip: "El costo total es el costo promedio de todos los productos",
			},
			validation: {
				selectProduct: "Selecciona un ingrediente",
				addQuantity: "Agrega una cantidad",
				lossGreaterThanQuantity: "El valor de pérdida no puede ser mayor que la cantidad",
				atLeastOneIngredient: "Agrega al menos un insumo a la ficha técnica",
				quantityGreaterThanZero: "El valor debe ser mayor que 0",
			},
		},
	},
	summary: {
		salePrice: "Precio de venta",
		totalCost: "Costo total",
		totalCostTooltip: "El costo total es el costo promedio de todos los productos",
		profitMargin: "Margen de ganancia",
		cmv: "CMV",
	},
	actions: {
		delete: "Eliminar ficha técnica",
		exportPdf: "Exportar PDF",
		deleteConfirmation: {
			title: "Eliminar ficha técnica",
			description:
				"Al confirmar la acción eliminas permanentemente la ficha técnica. ¿Deseas continuar?",
			confirm: "Sí, deseo eliminar",
			cancel: "Cancelar",
		},
		notifications: {
			deleteSuccess: "Ficha técnica eliminada con éxito",
			deleteError: "Error al eliminar la ficha técnica",
		},
	},
};
